import { render, staticRenderFns } from "./Load_Edit.vue?vue&type=template&id=31168406&"
import script from "./Load_Edit.vue?vue&type=script&lang=ts&"
export * from "./Load_Edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports